// extracted by mini-css-extract-plugin
module.exports = {"preview":"Preview_preview__V1cQA"};